import React from 'react';
import { formatSeasonDisplay } from '../../../utils/seasonHelpers';
import '../SeasonShell.css';
import './EmptySeasonCard.css';

interface EmptySeasonCardProps {
  seasonId: string;
}

export const EmptySeasonCard: React.FC<EmptySeasonCardProps> = ({ seasonId }) => {
  const displayName = formatSeasonDisplay(seasonId);

  return (
    <div className="season-shell empty-season-card">
      <div className="empty-season-content">
        <h3 className="empty-season-title">{displayName}</h3>
        <p className="empty-season-message">No events created yet</p>
        <p className="empty-season-hint">
          Create your first event to start adding photos to this season
        </p>
      </div>
    </div>
  );
};
